import { inject, Injectable } from '@angular/core'

import type { ProfileFull, SearchProfile } from '@app/models/profile'
import { ModalService } from '@app/overlays/modal/modal.service'

import { MessageModalComponent } from '../components/message-modal/message-modal.component'
import type { ConversationProfile } from '../models/conversation-profile.model'

@Injectable({
  providedIn: 'root',
})
export class MessagingUIService {
  private readonly modalService = inject(ModalService)
  private existingModalInstance = false

  openMessageModal(profile: SearchProfile | ProfileFull | ConversationProfile): void {
    if (this.existingModalInstance) {
      return
    }
    const { instance } = this.modalService.create(MessageModalComponent, {
      scrollable: false,
      padded: false,
      desktopWidth: '600px',
    })
    instance.profile = profile
    this.existingModalInstance = true
    instance.onClose(() => (this.existingModalInstance = false))
  }
}
